<template>
  <div class="commodityManage div-layout">
    <div>
      <module-title title="商品管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            新增商品
          </el-button>
        </div>
      </module-title>
      <div>
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          class="subjectSearchForm"
        >
          <el-form-item label="商品编码：" prop="specNo">
            <el-input
              v-model="searchForm.specNo"
              name="specNo"
              maxlength="200"
              placeholder="输入商品编码"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="商品名称：" prop="name">
            <el-input
              v-model="searchForm.name"
              name="name"
              maxlength="200"
              placeholder="输入商品名称"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="业务编码：" prop="code">
            <el-input
              v-model="searchForm.code"
              name="code"
              maxlength="200"
              placeholder="输入业务编码"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="商品类型：" prop="type">
            <el-select
              v-model="searchForm.type"
              name="type"
              size="medium"
              class="edit-form-input"
            >
              <el-option
                v-for="item in goodsTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="commodityList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="商品编码" prop="specNo" align="center" />
          <el-table-column label="商品名称" prop="name" align="center" />
          <el-table-column label="商品规格" prop="spec" align="center" />
          <el-table-column label="售价（元）" prop="price" align="center" />
          <el-table-column label="原价（元）" prop="originalPrice" align="center" />
          <!-- V17.1 -->
          <el-table-column label="会员价（元）" prop="vipPrice" align="center" />
          <el-table-column label="商品图片" prop="imgUrl" align="center">
            <template slot-scope="scope">
              <img v-show="scope.row.imgUrl" :src="scope.row.imgUrl" alt="商品图片" width="60">
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <!-- V17.1 -->
              <el-button
                type="primary"
                size="small"
                icon="el-icon-view"
                @click="opAddOrEdit('view',scope.row)"
              >
                详情
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit',scope.row)"
              >
                修改
              </el-button>
              <!-- <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                @click="handleDdelete(scope.row)"
              >删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.title"
      width="900px"
    >
      <AddEditCommodity :props-commodity="hiddenVariable.text" @closeCommodity="handleCloseCommodity" @fetchCommodityFn="fetchCommodity" />
    </el-dialog>
  </div>
</template>

<script>
import AddEditCommodity from './addEditCommodity';
import { getGoodsPageList } from '@/api/userManagement/index/';
import { mapGetters } from 'vuex';
export default {
  name: 'PortraitManage',
  components: {
    AddEditCommodity
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        productTerminal: '',
        advertisementPosition: '',
        advertisementType: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      hiddenVariable: {
        dialogEditVisible: false,
        title: '',
        text: {
        }
      },
      commodityList: [],
      listLoading: false, // 表格刷新loading
      dateTime: '',
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 || time.getTime() < Date.now() - 3 * 31 * 24 * 60 * 60 * 1000 - 8.64e7; // 如果有后面的-8.64e7就是不可以选择今天
        }
      }
    };
  },

  computed: {
    ...mapGetters(['userInfo']),
    goodsTypeList() {
      return [
        {
          id: '',
          name: '全部'
        },
        {
          id: 2,
          name: '组合商品'
        },
        {
          id: 1,
          name: '单品'
        }
      ];
    }
  },
  mounted() {
    this.fetchCommodity();
  },
  methods: {
    // 获取积分明细数据
    fetchCommodity() {
      this.listLoading = true;
      var option = {
        specNo: this.searchForm.specNo,
        name: this.searchForm.name,
        code: this.searchForm.code,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        type: this.searchForm.type
      };
      getGoodsPageList(option).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.commodityList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.commodityList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.commodityList = [];
        this.total = 0;
        this.listLoading = false;
      });
    },
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.startDate = val[0];
        this.endDate = val[1];
        this.fetchCommodity();
      } else {
        this.startDate = '';
        this.endDate = '';
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchCommodity();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchCommodity();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchCommodity();
    },
    opAddOrEdit(type, row) {
      this.hiddenVariable.dialogEditVisible = true;
      var title = ''; var id = '';
      type === 'add' ? title = '新增商品' : type === 'edit' ? title = '修改商品' : title = '查看商品';
      if (type === 'edit' || type === 'view') id = row.id;
      this.hiddenVariable.title = title;
      this.hiddenVariable.text = { type, id };
    },
    // handleDdelete(row) {
    //   this.listLoading = true;
    //   var option1 = {
    //     updateUser: this.userInfo.accountId
    //   };
    //   getGoodsDel(row.id, option1)
    //     .then(res => {
    //       this.listLoading = false;
    //       this.$notify.success({
    //         title: 'Success',
    //         message: '删除成功',
    //         showClose: false,
    //         duration: 2000
    //       });
    //       this.fetchCommodity();
    //     })
    //     .catch(() => {
    //       this.listLoading = false;
    //     });
    // },
    handleCloseCommodity() {
      this.hiddenVariable.dialogEditVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.commodityManage {
  padding-bottom: 20px;
  .subjectSearchForm{
    padding: 0 20px;
  }
}
.edit-form-input {
  width: 100px;
}
</style>
